export type Screen = 'teacher' | 'game';

export function screenOf(pathname: string): Screen {
  return pathname.startsWith('/play/') ? 'game' : 'teacher';
}
